<template>
  <div v-if="!loading">

    <!-- Input and textarea -->
    <content-field
      v-if="fieldLayout.type === 'string'"
      :label="fieldLayout.label"
      :multiLine="fieldLayout.multiline"
      v-model="innerModel"
      :error="error"
      @input="onInput($event)"
    />

    <!-- Checkbox or array of checkboxes -->
    <e-checkboxes
      v-if="fieldLayout.type === 'checkbox'"
      :title="fieldLayout.label"
      :checkboxes="fieldLayout.values"
      :error="error"
      :value="innerModel"
      @change="onInput($event)"
    />

    <!-- Radio buttons -->
    <e-radio-buttons 
      v-if="fieldLayout.type === 'radio'"
      :title="fieldLayout.label"
      :items="fieldLayout.values"
      :value="innerModel"
      :error="error"
      @input="onInput($event)"
    />

    <!-- Multiselect -->
    <e-multiselect
      v-if="fieldLayout.type === 'select'"
      :fieldLayout="fieldLayout"
      :title="fieldLayout.label"
      :value="innerModel"
      :error="error"
      @input="onInput($event)"
    />

    <!-- Image uploader -->
    <e-image-uploader
      v-if="fieldLayout.type === 'image'"
      :title="fieldLayout.label"
      :error="error"
      :value="innerModel"
      @change="onInput($event)"
    />

    <!-- Nested form fields. Runs recursive self rendering -->
    <div v-if="fieldLayout.type === 'array'">
      <h3>{{fieldLayout.label}}</h3>
      <v-card
        v-for="(row, i) in arrayFieldsNumber"
        :key="`recursive-row-${i}`"
        class="card_inner"
      >
        <custom-form-field
          v-for="(field, j) in fieldLayout.fields"
          :key="`recursive-field-${j}`"
          :fieldLayout="field.layout"
          :fieldMetadata="field.metadata"
          :formDataCopy="formDataCopy"
          :error="pathOr({}, [i, field.layout.property], error)"
          :level="nextLevel"
          :path="[...path, i, field.layout.property]"
        />
      </v-card>
    </div>
  </div>
</template>

<script>
import errorMessages from '@/modules/error-messages'
import { pathOr } from 'ramda'

import ContentField from 'shared/ContentField'
import ECheckboxes from 'shared/ECheckboxes'
import ERadioButtons from 'shared/ERadioButtons'
import EMultiselect from 'shared/EMultiselect'
import EImageUploader from 'shared/EImageUploader'
import CustormFormField from './NewCustormFormField'

export default {
  name: 'custom-form-field',
  components: {
    ContentField,
    ECheckboxes,
    EImageUploader,
    ERadioButtons,
    EMultiselect,
    CustormFormField
  },
  props: {
    fieldLayout: {
      type: Object,
      default: () => ({})
    },
    fieldMetadata: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: null // any
    },
    path: {
      type: Array,
      default: []
    },
    level: {
      type: Number,
      default: 0
    },
    formDataCopy: {
      type: Object
    },
    error: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      innerModel: null
    }
  },
  computed: {
    arrayFieldsNumber () {
      // care! could change in future
      return Number(this.fieldLayout.validators[0].data.max)
    },
    nextLevel () {
      return this.level + 1
    }
  },
  methods: {
    pathOr,
    onInput (value) {
      this.$bus.$emit('customFormInput', {
        path: this.path,
        value
      })
    }
  },
  created () {
    this.fieldLayout.type === 'checkbox'
      ? this.innerModel = [pathOr('', this.path, this.formDataCopy)]
      : this.innerModel = pathOr('', this.path, this.formDataCopy)
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
  .card_inner {
    padding: 10px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/FakeBlitzRegistration/NewCustormFormField.vue